module.exports = __webpack_public_path__ + "static/media/1980.416cdf57.jpeg";